import PropTypes from 'prop-types';
import React from 'react';

import {Anchor, Banner, Button, Dialogue} from '@albert-io/atomic';

const IBEUnlicensedError = ({handleClose, ...rest}) => {
  return (
    <Dialogue handleClose={handleClose} title='You need an active license to proceed' {...rest}>
      <Dialogue.Body>
        <Banner className='u-mar-b_2' theme='danger'>
          <Banner.Icon icon='exclamation-triangle' />
          <span>
            At this time, only licensed teachers are allowed to send email invitations. See
            our&nbsp;
            <Anchor as='a' href='/pricing-schools' inheritColor underlined>
              pricing page
            </Anchor>
            &nbsp;to learn about our available plans.
          </span>
        </Banner>
      </Dialogue.Body>
      <Dialogue.BtnGroup>
        <Button color='secondary' onClick={handleClose}>
          OK
        </Button>
      </Dialogue.BtnGroup>
    </Dialogue>
  );
};

IBEUnlicensedError.propTypes = {
  handleClose: PropTypes.func
};

export default IBEUnlicensedError;
